import styled from 'styled-components';

const colors = {
  borderActive: '#000FFF',
  backgroundActive: '#00FF00',
  inactive: '#D8D8D8',
  canceled: '#d80000'
};

const TimelineStepsContainer = styled.div`
  margin-top: 40px;
  margin-bottom: 30px;
`;

TimelineStepsContainer.StepsBox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  .box-text-step {
    text-align: center;
  }
  .white-color {
    color: #ffffff;
    cursor: normal;
  }
  @media (max-width: 772px) {
    flex-direction: column;
    align-items: start;
    height: 300px;
    .box-text-step {
      text-align: left;
      margin-left: 20px;
    }
  }
  span {
    display: block;
    font-size: 12px;
    color: #808080;
  }
  .blue {
    color: #000FFF;
  }
  .hide-item {
    opacity: 0;
    cursor: normal;
  }
`;

TimelineStepsContainer.Item = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 50;

  @media (min-width: 770px) {
    margin: ${props => props.notPurple ? props.saida ? "0 2rem 1rem 0" : "-1rem 0 0 0" : "0"};
  }

  @media (max-width: 772px) {
    flex-direction: row;
  }
`;

TimelineStepsContainer.Line = styled.div`
  background: ${colors.inactive};
  height: 1px;
  margin: 0 auto;
  margin-bottom: -14px;
  width: 601px;
  max-width: 100%;
  @media (max-width: 772px) {
    height: 285px;
    position: absolute;
    z-index: 1;
    width: 2px;
    margin: 0 auto;
    margin-bottom: -14px;
    margin-left: 11px;
    margin-top: 5px;
  }
`;

TimelineStepsContainer.Step = styled.div`
  background: ${props => (props.active || props.purple ? props.canceled ? colors.canceled : colors.backgroundActive : colors.inactive)};
  display: flex;
  justify-content: center;
  align-items: center;
  width: 25px;
  height: 25px;
  margin-bottom: 10px;
  border-radius: 50%;
  border: 4px solid white;
  box-shadow: 0px 0px 0px 2px
    ${props => (props.active || props.purple ? props.canceled ? colors.canceled : colors.borderActive : 'transparent')};

  @media(max-width: 770px) {
    margin: ${props => !props.active && props.purple ? "-1.2rem 0 0 0" : null};
  }
`;

export default TimelineStepsContainer;